export enum HUB_METHOD {
    TOKEN_VERIFY = 'TokenVerify',
    REGISTRATION_WITH_CONFIRMATION = 'RegistrationWithConfirmation',
    REGISTRATION_WITH_EMAIL_ONLY = 'RegistrationWithEmailOnly',
    REGISTRATION_WITH_PASSWORD = 'RegistrationWithPassword',
    CHECK_EMAIL_AVAILABLE = 'CheckEmailAvailable',
}
